import { render, staticRenderFns } from "./APCDelconEditAdmin.vue?vue&type=template&id=4b8b23a0&scoped=true"
import script from "./APCDelconEditAdmin.vue?vue&type=script&lang=js"
export * from "./APCDelconEditAdmin.vue?vue&type=script&lang=js"
import style0 from "./APCDelconEditAdmin.vue?vue&type=style&index=0&id=4b8b23a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b23a0",
  null
  
)

export default component.exports